var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGibbon = function SvgGibbon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.96,
    d: "m18.8 13.8-1.55-2.56-1.01-4.03-1.36-1.51c.06-.24.07-.4.07-.4.31-.89.48-1.73.4-2.5l-.9.08c-.48-.46-1.17-.81-2.04-.81-.87 0-1.56.34-2.04.81l-.9-.08c-.07.73.08 1.53.36 2.36l-1.71.93c-1.06.55-1.4 1.56-1.53 2.71l-1.64 4.38v1.7l1.33 1.53 1.15-.26-.03 1.5 1.61 2.56.2.46 1.23.23-.53.49 1.49.57 2.7-.48.26-.46c.32-.77.61-1.52.84-2.27l1.23-2.39 1.12.26 1.5-1.51-.26-1.28.01-.03Z"
  })));
};

export default SvgGibbon;